export class ProfileACL {
  static PRIVATE_PROFILE = 'private';

  static PUBLIC_PROFILE = 'public';

  static MENTOR_VIEW_PROFILE = 'mentor';


  constructor(renderType, userDetails) {
    this.renderType = renderType;
    this.userDetails = userDetails;
  }

  isMentor() {
    return (this.renderType === ProfileACL.MENTOR_VIEW_PROFILE);
  }

  isPrivate() {
    return (this.renderType === ProfileACL.PRIVATE_PROFILE);
  }

  isPublic() {
    return (this.renderType === ProfileACL.PUBLIC_PROFILE);
  }

  showShareButton() {
    if (this.isPrivate()) {
      return true;
    } else {
      if (this.userDetails.profile_page_hidden) {
        return false;
      }
      return true;
    }
  }
}

export default ProfileACL;
